import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-20 pb-24 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-74">
      {/* Background glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-accent/5 rounded-full blur-3xl pointer-events-none" data-id="element-75" />

      <div className="relative max-w-4xl mx-auto text-center" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-77">
          <span className="inline-block py-1 px-3 rounded-full bg-brand-card border border-brand-accent/20 text-brand-accent text-sm font-semibold tracking-wide mb-6" data-id="element-78">
            GEORGE CAPITAL COACHING
          </span>

          <h1 className="text-4xl sm:text-5xl md:text-6xl font-serif font-bold text-white leading-tight mb-6" data-id="element-79">
            Cómo ordenar tus finanzas en 30 días{' '}
            <br className="hidden md:block" data-id="element-80" />
            <span className="text-brand-accent italic" data-id="element-81">
              (y recuperar el control de tu sueldo)
            </span>{' '}
            <br className="hidden md:block" data-id="element-82" />
            sin usar una sola hoja de Excel.
          </h1>

          <p className="text-lg sm:text-xl text-slate-300 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-83">
            El sistema pragmático para que tu dinero deje de desaparecer en
            gastos invisibles. Resultados reales en 4 semanas.
          </p>

          <div className="flex flex-col items-center gap-4" data-id="element-84">
            <a href="#cta" className="group relative inline-flex items-center justify-center gap-3 bg-brand-accent text-brand-dark px-8 py-4 rounded-lg font-bold text-lg sm:text-xl hover:bg-brand-accentHover transition-all hover:scale-105 active:scale-95 shadow-[0_0_40px_-10px_rgba(245,158,11,0.5)]" data-id="element-85">
              SÍ, QUIERO EL MÉTODO POR $6.36
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-86" />
            </a>

            <div className="flex items-center gap-2 text-sm text-slate-400 mt-4" data-id="element-87">
              <ShieldCheck className="w-4 h-4 text-brand-accent" data-id="element-88" />
              <span data-id="element-89">Acceso inmediato y de por vida</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}